export default __webpack_public_path__ + "static/media/Eye.d071abf6.webp";